import React from 'react';
import MobileFilterAutocomplete from './MobileFilterAutocomplete';

export default function MobileCategoryPicker({
  categories,
  value,
  onChange,
  disabled = false,
  label = 'Категорії',
}) {
  return (
    <fieldset className='mp-category-picker' disabled={disabled}>
      <MobileFilterAutocomplete
        label={label}
        options={categories.map(category => ({ value: category.id, label: category.name }))}
        value={value}
        onChange={onChange}
        disabled={disabled}
        missingLabel={id => `Категорія #${id}`}
        placeholder='Знайти категорію'
      />
    </fieldset>
  );
}
